/* unplugin-vue-components disabled */import { render } from "./standardmap-template2.vue?vue&type=template&id=7a6e2aab&scoped=true"
import script from "./standardmap-template2.vue?vue&type=script&lang=js"
export * from "./standardmap-template2.vue?vue&type=script&lang=js"

import "./standardmap-template2.vue?vue&type=style&index=0&id=7a6e2aab&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6e2aab"]])

export default __exports__